import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isValid } from 'date-fns';
import _ from "lodash";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputBase from '@material-ui/core/InputBase';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import TextField from '@material-ui/core/TextField';
import { authHeader, parseWindowsOS, history } from '../../helpers';
import api from '../../constants/api';
import BreadCrumbNav from '../BreadCrumbNav'
import { getUser, checkError } from '../../helpers';
import Autocomplete from '@material-ui/lab/Autocomplete';
import './TerminalEdit.css';
import swal from 'sweetalert';
import { postApi } from '../../helpers/http';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid rgb(118, 118, 118)',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class TerminalEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      limit: 1000,
      startDate: "",
      openTerminalSelector: false,
      terminalModel: "0",
      pc_name: "",
      tmp_pc_name:"",
      tmp_terminalIndex: -1,
      terminalIndex: -1,
      terminals: [],
      openAlert: false,
      editSuccess: false,
      user_id: "",
      user_name: ""
    };
  }

  componentDidMount() {
    const { getTerminals, getSettings, getOsSettings } = this.props
    const params = {
      offset: this.state.offset * this.state.limit,
      limit: this.state.limit
    };
    getTerminals(params);

    const paramsUserMaster = {
      offset: 0,
      limit: this.state.limit,
      table_name: "user_master"
    };
    getSettings(paramsUserMaster);

    const osparams = {
      offset: this.state.offset * this.state.limit,
      limit: this.state.limit
    };
    getOsSettings(osparams)
  }

  render() {
    const user = getUser()
    const { items, isFetching, usersMaster, ositems } = this.props
    // 端末番号
    // let filtered_status = (items.detailData || []).filter(item => item.statusKb !== "2");
    // let pc_names = _.map(filtered_status, "pc_name");
    let pc_names = _.map(items.detailData, "pc_name");
    pc_names = _.uniq(pc_names);
    // pc_names = _.sortBy(pc_names);
    pc_names.sort((a, b) => a.localeCompare(b, undefined, {sensitivity: "base",numeric: true}));

    const sortedUsers = [...(usersMaster.detailData || [])].sort((a, b) =>
      (a.name || "").localeCompare(b.name || "", undefined, {
        sensitivity: "base",
        numeric: true
      })
    );

    // os_info
    if (isFetching === false && ositems.detailData && items.detailData && items.detailData.length > 0 && ositems.detailData.length > 0) {
      for (var isp = 0; isp < items.detailData.length; isp++) {
        if(items.detailData[isp].os_id === "None" || items.detailData[isp].os_id === "-1" || items.detailData[isp].os_id === -1){
          const os_info = parseWindowsOS(items.detailData[isp].os_info);
          for (var ios = 0; ios < ositems.detailData.length; ios++) {
            if(os_info.indexOf(ositems.detailData[ios].name)!==-1){
              items.detailData[isp].os_id = ositems.detailData[ios].i_num;
              break;
            }
          }
        }
      }
    }

    const changeTemminalName = (event) => {
      const {value} = event.target;

      if (value === "") {
        this.setState({
          openTerminalSelector: false,
          terminalIndex: -1,
          tmp_terminalIndex: -1,
          tmp_pc_name: "",
          pc_name: "",
          terminals: [],
          startDate: ""
        });
        return;
      }

      const terminalsFilter = _.filter(items.detailData, ['pc_name', value]);
      var terminals = [];
      for (var i = 0; i < terminalsFilter.length; i++) {
        terminals.push({...terminalsFilter[i]});
      }
      // console.log(terminals);
      let strToDate = "";
      let used_start_time = ""
      if (terminals.length > 0) {
        // const used_start_time = terminals[0].used_start_time;
        used_start_time = terminals[0].used_start_time;
        const date1 = new Date(used_start_time);
        if (used_start_time && used_start_time.length >= 10 && isValid(date1)) {
          strToDate = used_start_time.substring(0, 10); // new Date(used_start_time.substring(0, 10));
        }
      }
      
      // console.log(date1, strToDate);
      // console.log("terminals", terminals);
      // console.log(terminals[0].os_id);
      this.setState({openTerminalSelector: true, 
                  terminalIndex: 0, 
                  tmp_terminalIndex: 0,
                  tmp_pc_name: value, 
                  pc_name: value, 
                  terminals,
                  startDate: strToDate
                });

    };

    const changeTemminalModel = (event) => {
      const {value} = event.target;
      // console.log("changeTemminalModel", value);
      const Index = _.findIndex(this.state.terminals, function(o) { return o.i_num === value; });
      this.setState({terminalIndex: Index});
    };

    const changeUserMaster = (event) => {
      const {id, name} = event.target;
      if (this.state.terminalIndex >= 0) {
        const terminals = this.state.terminals;
        terminals[this.state.terminalIndex].user_id = id;
        terminals[this.state.terminalIndex].user_name = name;
        this.setState({terminals, user_id: id, user_name: name});
      }
    };

    const changeTemminalOs = (event) => {
      const {value} = event.target;
      if (this.state.terminalIndex >= 0) {
        const terminals = this.state.terminals;
        terminals[this.state.terminalIndex].os_id = value;
        this.setState({terminals});
      }
    };
    
    const handleRadioChange = (event) => {
      const { value } = event.target;
      const Index = _.findIndex(this.state.terminals, function (o) { return o.mac_add === value; });
      this.setState({ terminalIndex: Index });

      if (Index >= 0) {
        // console.log(Index, this.state.terminals);
        const used_start_time = this.state.terminals[Index].used_start_time;
        let strToDate = "";
        const date1 = new Date(used_start_time);
        if (used_start_time && used_start_time.length >= 10 && isValid(date1)) {
          strToDate = used_start_time.substring(0, 10); // new Date(used_start_time.substring(0, 10));
          this.setState({ startDate: strToDate });
        }
      }
    };

    const handleClose = (event) => {
      this.setState({openTerminalSelector: false});
    };

    const handleEdit = async (event) => {
      // console.log("登録押下");
      if (this.state.terminalIndex === -1) {
        // console.log("terminalIndex === -1");
        swal({
           title: "設定エラー！",
           text: "端末名を入力してください。",
           icon: "warning",
           button: "はい"
        });
        return;
      }
      const terminal = this.state.terminals[this.state.terminalIndex];
      swal({
        title: "変更を保存しますか？",  
        icon: "warning",
        buttons: ["いいえ", "はい"],
        dangerMode: true,
      })

      .then(async (confirm) => {
        if (confirm) {
          const data = {
            "process_type": "updateTerminal",
            "used_start_time": this.state.startDate !== "" ? new Date(this.state.startDate).toISOString().replace('T', ' ').slice(0, 19) : "",
            "user_id": Number(terminal.user_id),
            "os_id": Number(terminal.os_id),   
            "mac_add": terminal.mac_add
          };

          try {
            const json = await postApi(data);
            if (json.statusCode == 200) {
              // console.log(json);
              this.setState({pc_name:"", terminalIndex: -1, startDate: ""});
              const { getTerminals } = this.props;
              const params = {
                offset: this.state.offset * this.state.limit,
                limit: this.state.limit
              };
              getTerminals(params);
              // this.forceUpdate();
              swal({
                title: "変更しました。",
                icon: "success",
                buttons: "はい"
              })
            } else {
              swal({
                title: "設定エラー！",
                text:  json.data || "変更に失敗しました。",
                icon: "warning",
                button: "はい",
              });
            };
          } catch (error) {
            swal({
              title: "設定エラー！",
              text:  "変更に失敗しました。",
              icon: "warning",
              button: "はい",
            });
          };

        } else {
          swal.stopLoading();
          swal.close();
        }
      })
      .catch((err) => {
        if (err) {
          swal({
            title: "エラー！",
            text:  "予期しないエラーが発生しました。",
            icon: "error",
            buttons: "はい"
          });
        }
      });
    };

    const handleCloseSuccess = () => {
      this.setState({openAlert: false,});
    };

    const handleChangePage = (event) => {
      if (event.target.value === "new") {
        history.push('/index.html?p=terminal-new');
      }
    };

    const handleOnBlurPcName = (event) => {
      if (this.state.tmp_terminalIndex == -1) {
        changeTemminalName({
          target: { value: "" }
        });
      };
    };

    const handleOnBlur = (event) => {
      if (this.state.user_id == -1) {
        const terminals = this.state.terminals;
        terminals[this.state.terminalIndex].user_id = -1;
        terminals[this.state.terminalIndex].user_name = "";
        this.setState({terminals, user_id: -1, user_name: ""});
      }
    };

    const changeStartDate = (event) => {
      const {value} = event.target;
      this.setState({
        startDate: value
      });
    };

    return (
      <div className="content-container">
        <BreadCrumbNav screenName="登録端末編集"></BreadCrumbNav>
        <div className="loginname">ログイン名：{user.username}</div>

        <h1 className="terminaledit__heading">登録端末編集</h1>
       
        <div className="terminaledit-form__switch-group">
          <div className="terminaledit-form__group-border">
            <RadioGroup aria-label="terminaledit" name="terminaledit" value={"edit"} onChange={handleChangePage}>
              <FormControlLabel value="edit" control={<Radio style={{height: 24}}  color="primary"/>} label="現在端末に使用者紐付け・変更" />
              <FormControlLabel value="new" control={<Radio style={{height: 24}}  color="primary"/>} label="新規登録" />
            </RadioGroup>
          </div>
        </div>
        
        <div className="terminaledit-form">
          <div className="terminaledit-form__group-item">
            <div className="terminaledit-form__item-title">
              <span>端末名</span>
            </div>
            <Autocomplete
              freeSolo
              className="terminaledit-form__item-value"
              options={pc_names || []}
              value={this.state.pc_name || null}
              inputValue={this.state.tmp_pc_name}
              onChange={(event, newValue, reason) => {
                if (reason === "clear") {
                  this.setState({
                    tmp_pc_name: "",
                    tmp_terminalIndex: -1
                  });
                  changeTemminalName({
                    target: { value: "" }
                  });
                  return;
                }
                changeTemminalName({
                  target: { value: newValue || "" }
                });
              }}
              onInputChange={(event, newInputValue, reason) => {
                if (reason === "clear") {
                  this.setState({
                    tmp_pc_name: "",
                    tmp_terminalIndex: -1
                  });
                  return;
                }

                this.setState({
                    tmp_pc_name: newInputValue,
                    tmp_terminalIndex: -1
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="autocomplete-filter"
                  variant="outlined"
                  onBlur={handleOnBlurPcName}
                />
              )}
              clearOnEscape
              // isOptionEqualToValue={(option, value) => option === value}
            />
          </div>
          <div className="terminaledit-form__group-item">
            <div className="terminaledit-form__item-title"><span>名前</span></div>
            <Autocomplete
              freeSolo
              className="terminaledit-form__item-value"
              options={sortedUsers || []}
              getOptionLabel={(option) => 
                typeof option === "string" ? option : option?.name || ""
              }
              value={
                this.state.terminals.length > 0 &&
                this.state.terminalIndex >= 0
                  ? usersMaster.detailData?.find(
                      u => u.i_num === this.state.terminals[this.state.terminalIndex].user_id
                    ) || null
                  : null
              }
              inputValue={this.state.user_name}
              onChange={(event, newValue) => {
                changeUserMaster({
                  target: {
                    id: newValue ? newValue.i_num : -1,
                    name: newValue ? newValue.name : ""
                  }
                });
              }}
              onInputChange={(event, newInputValue) => {
                this.setState({
                    user_id: -1,
                    user_name: newInputValue
                });
              }}
              disabled={this.state.pc_name === '' || this.state.pc_name === null}
              // isOptionEqualToValue={(option, value) => option.i_num === value.i_num}
              clearOnEscape
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="autocomplete-filter"
                  variant="outlined"
                  onBlur={handleOnBlur}
                />
              )}
            />
          </div>
          <div className="terminaledit-form__group-item">
            <div className="terminaledit-form__item-title"><span>部</span></div>
            <NativeSelect className="terminaledit-form__item-value"
              id="demo-customized-select-native"
              value={this.state.terminals.length > 0 && this.state.terminalIndex >= 0 ? this.state.terminals[this.state.terminalIndex].user_id || -1: -1}
              input={<BootstrapInput />}
              disabled={true}
            >
              <option aria-label="無し" value="" />
              {usersMaster.detailData && (usersMaster.detailData).map((userMaster, index) => (
                <option value={userMaster.i_num} key={index}>{userMaster.section_name}</option>
              ))}
            </NativeSelect>
          </div>

          <div className="terminaledit-form__group-item">
            <div className="terminaledit-form__item-title"><span>課</span></div>
            <NativeSelect className="terminaledit-form__item-value"
              id="demo-customized-select-native"
              value={this.state.terminals.length > 0 && this.state.terminalIndex >= 0 ? this.state.terminals[this.state.terminalIndex].user_id || -1: -1}
              input={<BootstrapInput />}
              disabled={true}
            >
              <option aria-label="無し" value="" />
              {usersMaster.detailData && (usersMaster.detailData).map((userMaster, index) => (
                <option value={userMaster.i_num} key={index}>{userMaster.department_name}</option>
              ))}
            </NativeSelect>
          </div>

          <div className="terminaledit-form__group-item">
            <div className="terminaledit-form__item-title"><span>製造元／モデル／シリアル</span></div>
            <NativeSelect className="terminaledit-form__item-value"
              id="demo-customized-select-native"
              value={this.state.terminals.length > 0 && this.state.terminalIndex >= 0 ? this.state.terminals[this.state.terminalIndex].mac_add: -1}
              onChange={changeTemminalModel}
              input={<BootstrapInput />}
              disabled={this.state.terminalIndex >= 0}
            >
              <option aria-label="無し" value="" />
              {(this.state.terminals).map((terminal, index) => (
                <option value={terminal.mac_add} key={index}>{`${terminal.manufacturer}／${terminal.system_model}／${terminal.serial_number}`}</option>
              ))}
            </NativeSelect>
          </div>

          <div className="terminaledit-form__group-item">
            <div className="terminaledit-form__item-title"><span>使用開始日</span></div>
            {/* <DatePicker className="terminaledit-form__datepicker-input"
              dateFormat="yyyy/MM/dd ～"
              selected={this.state.startDate}
              onChange={(date) => this.setState({startDate: date})}
            /> */}
            <div className="terminaledit-form__datepicker">
              <TextField className="terminaledit-form-input"
                variant="outlined"
                id="startDate"
                type="date"
                value={this.state.startDate}
                onChange={changeStartDate}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
          </div>

          <div className="terminaledit-form__group-item">
            <div className="terminaledit-form__item-title"><span>OS</span></div>
            <NativeSelect className="terminaledit-form__item-value"
              id="demo-customized-select-native"
              value={this.state.terminals.length > 0 && this.state.terminalIndex >= 0 ? this.state.terminals[this.state.terminalIndex].os_id: -1}
              onChange={changeTemminalOs}
              input={<BootstrapInput />}
            >
              <option aria-label="無し" value="" />
              {ositems.detailData && (ositems.detailData).map((ositem, index) => (
                <option value={ositem.i_num} key={index}>{ositem.name}</option>
              ))}
            </NativeSelect>
          </div>

          <div className="terminaledit-form__controls">
            <button className="terminaledit-btn" onClick={handleEdit}>登録</button>
          </div>
        </div>

        <Dialog open={this.state.terminals.length > 1 && this.state.openTerminalSelector} onClose={handleClose} aria-labelledby="form-dialog-title">
          <DialogContent>
            <DialogContentText>
            「端末名：{this.state.pc_name}」について、ＤＢに複数の端末情報が存在します。<br/>
            登録するものを次の中から選択してください。
            </DialogContentText>
            <FormControl component="fieldset" style={{marginTop: 20, marginBottom: 0}}>
              <RadioGroup aria-label="terminalmodel" name="terminalmodel" 
                  value={this.state.terminals.length > 0 && this.state.terminalIndex >= 0 ? this.state.terminals[this.state.terminalIndex].mac_add: -1}
                  onChange={handleRadioChange}>
                {this.state.terminals && (this.state.terminals).map((terminal, index) => (
                  <FormControlLabel value={terminal.mac_add} key={index} control={<Radio />} label={`${terminal.manufacturer}／${terminal.system_model}／${terminal.serial_number}`} />
                ))}
              </RadioGroup>
            </FormControl>
          </DialogContent>
          <DialogActions style={{marginBottom: 20}}>
            <Button variant="outlined" onClick={handleClose} color="primary" style={{margin: "auto"}}>
              選択
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar open={this.state.openAlert} autoHideDuration={6000} onClose={handleCloseSuccess}>
          <Alert onClose={handleCloseSuccess} severity={this.state.editSuccess ? "success" : "error"}>
            {this.state.editSuccess ? "登録しました。" : "登録に失敗しました。"}
          </Alert>
        </Snackbar>
      </div>
    );
  }
}

TerminalEdit.propTypes = {
  getTerminals: PropTypes.func.isRequired,
  getSettings: PropTypes.func.isRequired,
  getOsSettings: PropTypes.func.isRequired,
};

export default TerminalEdit;